import classes from './FormNextBtn.module.css'

const FormNextBtn = (props) => <a onClick={props.clickHandler} className={classes['next-button']}>Next</a>

export default FormNextBtn;